import { assign, fromPromise, setup } from 'xstate';
import { runAnalysisPipeline, type AnalysisResult } from '../lib/analysis';
export interface AnalysisContext{domain:string;result:AnalysisResult|null;error:string|null;runCount:number}
type AnalysisEvent={type:'ANALYZE';domain:string}|{type:'CANCEL'}|{type:'RESET'};
export const analysisMachine=setup({
  types:{context:{} as AnalysisContext,events:{} as AnalysisEvent},
  actors:{analyze:fromPromise(async({input,signal}:{input:{domain:string};signal:AbortSignal})=>runAnalysisPipeline(input.domain,signal))}
}).createMachine({
  id:'analysis',initial:'idle',context:{domain:'',result:null,error:null,runCount:0},
  states:{
    idle:{on:{ANALYZE:{target:'running',actions:assign({domain:({event})=>event.domain,error:()=>null})}}},
    running:{
      entry:assign({error:()=>null,runCount:({context})=>context.runCount+1}),
      invoke:{src:'analyze',input:({context})=>({domain:context.domain}),
        onDone:{target:'success',actions:assign({result:({event})=>event.output,error:()=>null})},
        onError:{target:'failure',actions:assign({error:({event})=>event.error instanceof Error?event.error.message:String(event.error)})}},
      on:{
        ANALYZE:{target:'running',reenter:true,actions:assign({domain:({event})=>event.domain,error:()=>null})},
        CANCEL:{target:'idle'}
      }
    },
    success:{on:{
      ANALYZE:{target:'running',actions:assign({domain:({event})=>event.domain,error:()=>null})},
      RESET:{target:'idle',actions:assign({domain:()=>'',result:()=>null,error:()=>null})}
    }},
    failure:{on:{
      ANALYZE:{target:'running',actions:assign({domain:({event})=>event.domain,error:()=>null})},
      RESET:{target:'idle',actions:assign({error:()=>null})}
    }}
  }
});
